import { render, staticRenderFns } from "./remoteBooking.vue?vue&type=template&id=df629ff0&"
import script from "./remoteBooking.vue?vue&type=script&lang=js&"
export * from "./remoteBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df629ff0')) {
      api.createRecord('df629ff0', component.options)
    } else {
      api.reload('df629ff0', component.options)
    }
    module.hot.accept("./remoteBooking.vue?vue&type=template&id=df629ff0&", function () {
      api.rerender('df629ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/remoteBooking.vue"
export default component.exports